var _path, _path2, _path3, _g, _g2, _g3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernmentSimplified(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.83,43.49H1.39c-.46,0-.86-.31-.97-.76-.11-.44.09-.91.5-1.12L48.97,15.88c.29-.16.65-.16.94,0l48.38,25.73c.41.22.61.68.5,1.12-.11.45-.51.76-.97.76ZM5.37,41.49h88.45l-44.37-23.6L5.37,41.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.45,17.76c-.55,0-1-.45-1-1V1.15c0-.55.45-1,1-1s1,.45,1,1v15.61c0,.55-.45,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.02,13h-14.57c-.55,0-1-.45-1-1s.45-1,1-1h12.84l-2.27-3.93c-.18-.31-.18-.69,0-1l2.27-3.93h-12.84c-.55,0-1-.45-1-1s.45-1,1-1h14.57c.36,0,.69.19.87.5.18.31.18.69,0,1l-2.85,4.93,2.85,4.93c.18.31.18.69,0,1-.18.31-.51.5-.87.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.07,46.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.53,46.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.53,88.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.07,88.89"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.19,49.25H11.73c-.55,0-1-.45-1-1v-4.74c0-.55.45-1,1-1s1,.45,1,1v3.74h15.46v-3.74c0-.55.45-1,1-1s1,.45,1,1v4.74c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.19,92.04c-.55,0-1-.45-1-1v-3.29h-15.46v3.29c0,.55-.45,1-1,1s-1-.45-1-1v-4.29c0-.55.45-1,1-1h17.46c.55,0,1,.45,1,1v4.29c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.12,87.14c-.55,0-1-.45-1-1v-37.89c0-.55.45-1,1-1s1,.45,1,1v37.89c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.81,87.14c-.55,0-1-.45-1-1v-37.89c0-.55.45-1,1-1s1,.45,1,1v37.89c0,.55-.45,1-1,1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.21,46.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.67,46.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.67,88.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.21,88.89"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,49.25h-17.46c-.55,0-1-.45-1-1v-4.74c0-.55.45-1,1-1s1,.45,1,1v3.74h15.46v-3.74c0-.55.45-1,1-1s1,.45,1,1v4.74c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,92.04c-.55,0-1-.45-1-1v-3.29h-15.46v3.29c0,.55-.45,1-1,1s-1-.45-1-1v-4.29c0-.55.45-1,1-1h17.46c.55,0,1,.45,1,1v4.29c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.26,87.14c-.55,0-1-.45-1-1v-37.89c0-.55.45-1,1-1s1,.45,1,1v37.89c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.95,87.14c-.55,0-1-.45-1-1v-37.89c0-.55.45-1,1-1s1,.45,1,1v37.89c0,.55-.45,1-1,1Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.51,46.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.97,46.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.97,88.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.51,88.89"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,49.25h-17.46c-.55,0-1-.45-1-1v-4.74c0-.55.45-1,1-1s1,.45,1,1v3.74h15.46v-3.74c0-.55.45-1,1-1s1,.45,1,1v4.74c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,92.04c-.55,0-1-.45-1-1v-3.29h-15.46v3.29c0,.55-.45,1-1,1s-1-.45-1-1v-4.29c0-.55.45-1,1-1h17.46c.55,0,1,.45,1,1v4.29c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.56,87.14c-.55,0-1-.45-1-1v-37.89c0-.55.45-1,1-1s1,.45,1,1v37.89c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25,87.14c-.55,0-1-.45-1-1v-37.89c0-.55.45-1,1-1s1,.45,1,1v37.89c0,.55-.45,1-1,1Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.83,99.07H1.39c-.55,0-1-.45-1-1v-6c0-.55.45-1,1-1h96.44c.55,0,1,.45,1,1v6c0,.55-.45,1-1,1ZM2.39,97.07h94.44v-4H2.39v4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.61,36.67c-3.96,0-7.18-3.16-7.18-7.04s3.22-7.04,7.18-7.04,7.18,3.16,7.18,7.04-3.22,7.04-7.18,7.04ZM49.61,24.58c-2.86,0-5.18,2.26-5.18,5.04s2.32,5.04,5.18,5.04,5.18-2.26,5.18-5.04-2.32-5.04-5.18-5.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentSimplified);
export default __webpack_public_path__ + "static/media/Government_Simplified.9446cc0106122cdf8f14a04aad1ec7d7.svg";
export { ForwardRef as ReactComponent };